import {IGoldBalance, ITransactionDetails, IValidation} from "StateInterface";
import * as React from "react";
import {imageBaseUrl} from "config";
import {handleNavigation, routePaths} from "egold/routes";
import {IBankInput} from "egold/pages/sellGold/bankDetails";
import {validateName} from "userform/utils";
import * as moment from "moment";
import {minGoldPurchaseAmount} from "egold/pages/buyGold";

export enum EGoldField {
    RUPEES = "inRupees",
    GRAMS = "inGrams",
}
export enum BankDetailFields {
    ACCOUNT_NO= "ACCOUNT_NO",
    RE_ACCOUNT_NO = "RE_ACCOUNT_NO",
    IFSC = "IFSC",
    NAME = "NAME",
    AC_HOLDER_NAME = "AC_HOLDER_NAME",
}
export enum HeaderTitle {
    BUY = "Buy Gold",
    SELL = "Sell Gold",
    DELIVERY = "Get Delivery",
    LOCKER = "Locker",
    ORDERS = "View Orders",
}
export const initialValidationStatus = {
    status: false,
    msg: "",
    type: "",
};
export enum RegisterUserField {
    NAME = "name",
    MOBILE = "mobile_no",
    EMAIL = "email",
    PIN = "pin_code",
}
export enum ToastBgColor {
    RED = "#E37048",
    GREEN = "#6CCB3C",
    WARNING = "#E5DC4E",
    DARK = "#4a4a4a",
}

export function validateBuyGold(inRupees: string, inGrams: string): IValidation {
    const validation: IValidation = JSON.parse(JSON.stringify(initialValidationStatus));
    if (!inRupees) {
        validation.msg = "Required";
        validation.type = EGoldField.RUPEES;
    } else if (inRupees && Number(inRupees) < minGoldPurchaseAmount) {
        validation.msg = `Minimum Rs. ${minGoldPurchaseAmount}`;
        validation.type = EGoldField.RUPEES;
    } else if ( inGrams && Number(inGrams) > 30) {
        validation.msg = "Maximum 30(gm)s";
        validation.type = EGoldField.GRAMS;
    } else {
        validation.status = true;
    }
    return validation;
}
export function validateSellGold(inRupees: string, inGrams: string, balance: IGoldBalance): IValidation {
    const validation: IValidation = JSON.parse(JSON.stringify(initialValidationStatus));
    if (!Number(inRupees) || Number(inRupees) < 1 ) {
        validation.msg = "Required min Rs.1";
        validation.type = EGoldField.RUPEES;
    } else if (inGrams && Number(inGrams) > 30) {
        validation.msg = "Maximum 30(gm)s";
        validation.type = EGoldField.GRAMS;
    } else if (Number(inGrams) > Number(balance.gold_balance)) {
        validation.msg = "Insufficient balance";
        validation.type = EGoldField.GRAMS;
    } else {
        validation.status = true;
    }
    return validation;
}
export function validateBankDetails(bankDetails: IBankInput): IValidation {
    const validation: IValidation = JSON.parse(JSON.stringify(initialValidationStatus));
    if (bankDetails.AC_HOLDER_NAME.trim() === "") {
        validation.msg = "Required field";
        validation.type = BankDetailFields.AC_HOLDER_NAME;
    } else if (!validateName(bankDetails.AC_HOLDER_NAME)) {
        validation.msg = "Invalid Name";
        validation.type = BankDetailFields.AC_HOLDER_NAME;
    } else if (bankDetails.ACCOUNT_NO.trim() === "") {
        validation.msg = "Required field";
        validation.type = BankDetailFields.ACCOUNT_NO;
    } else if (bankDetails.ACCOUNT_NO !== bankDetails.RE_ACCOUNT_NO) {
        validation.msg = "Account number mismatch";
        validation.type = BankDetailFields.RE_ACCOUNT_NO;
    } else if (bankDetails.IFSC.length !== 11) {
        validation.msg = "IFSC invalid";
        validation.type = BankDetailFields.IFSC;
    } else {
        validation.status = true;
    }
    return validation;
}
export function renderProceed(title: string, handleProceed: () => void, disabled?: boolean) {
    return(
        <button className={`mt-3 mb-3 eGold-submit-btn ${disabled && "inactive"}`}
                onClick = {() => handleProceed()}
                disabled={disabled}
        >
            {title}
        </button>
    );
}

export function HowItWorks() {
    const points = [
        {
            text: "Select Gold Coin",
            icon: `${imageBaseUrl}/img/icons/eGold/tap.svg`,
        },
        {
            text: "Pay Making Charges",
            icon: `${imageBaseUrl}/img/icons/eGold/rupee.svg`,
        },
        {
            text: "Get Home Delivery",
            icon: `${imageBaseUrl}/img/icons/eGold/cargo-box.svg`,
        },
    ];
    return (
        <div className={"w-100 how-it-works-body"}>
            <div className={"text-center how-it-works-heading"}>
                How it works?
            </div>
            {
                points.map((point, index) => {
                    return (
                        <div className={"how-it-works-points"} key={index}>
                            <img src={point.icon} alt="how-it-works-icon"/> <br/>
                            <p className={"pt-2 m-0"}>{point.text}</p>
                        </div>
                    );
                })
            }
        </div>
    );
}
export const getAddressFields = (info?: any) => [
    {
        inputType: "text",
        label: "Name",
        name: "name",
        value: "",
    },
    {
        inputType: "text",
        label: "Address (Flat/House no, Street)",
        name: "address",
        value: "",
    },
    {
        inputType: "text",
        label: "Landmark",
        name: "landmark",
        value: "",
    },
    {
        inputType: "text",
        label: "City",
        name: "city",
        value: info ? info.city : "",
    },
    {
        inputType: "text",
        label: "State",
        name: "state",
        value: info ? info.state : "",
    },
    {
        inputType: "number",
        label: "Pincode",
        name: "pincode",
        value: info ? info.pincode : "",
        disabled: true,
    },
];

export const getRegisterUserFields = (email: string) => [
    {
        inputType: "text",
        label: "Name",
        name: RegisterUserField.NAME,
        value: "",
    },
    {
        inputType: "number",
        label: "Mobile",
        name: RegisterUserField.MOBILE,
        value: "",
    },
    {
        inputType: "text",
        label: "Email",
        name: RegisterUserField.EMAIL,
        value: email,
        disabled: true,
    },
    {
        inputType: "number",
        label: "Pincode",
        name: RegisterUserField.PIN,
        value: "",
    },
];

export function profileStyle() {
    return {
        handleContainerStyle: (hasError) => {
            return {
                fontSize: "14px",
                color: "rgb(140, 140, 140)",
                margin: "0 10px",
            };
        },
        submitButtonStyle: {
            backgroundColor: "#F5821F",
            cursor: "pointer",
            color: "#FFFFFF",
            border: "none",
            padding: "10px",
            width: "100%",
            borderRadius: "25px",
            boxShadow: "0px 1px 3px 1px #e0e0e0",
        },
        inputStyle: {
            handleTextFieldStyle: (hasError) => {
                return {
                    color: "#495057",
                    border: "none",
                    borderBottom: `1px solid ${hasError ? "red" : "lightgray"}`,
                    padding: ".5rem 0",
                    width: "100%",
                    marginBottom: "5px",
                };
            },
        },
        handleErrorStyle: (hasError) => {
            return {
                color: "red",
                font: "12px",
            };
        },
    };
}

export function roundDown(num: number, upto: number) {
    const t = Math.pow(10, upto);
    return Math.floor(Number(num) * t) / t;
}

export function roundWithUpperValue(num: number, upto: number) {
    const t = Math.pow(10, upto);
    return Math.ceil(Number(num) * t) / t;
}
export function renderEmptyMessage(image: string, title: string, subText: string) {
    return(
        <div className="locker-empty text-center p-4">
            <img src={image} height={150}
                 style={{marginTop: "20%"}}
            />
            <h5 style={{color: "#000000"}}>{title}</h5>
            <p style={{fontSize: "13px"}}>{subText}</p>
            <button className="p-2 mt-2 mb-3 eGold-submit-btn"
                    style={{width: "70%", margin: "auto"}}
                    onClick={() => handleNavigation(routePaths.BUY_GOLD)}
            >
                Buy Gold Now
            </button>
        </div>
    );
}

export function removeCountryCode(value: string) {
    if (value.startsWith("+")) {
        value = value.substring(3, value.length);
    }
    return value;
}

export function toUpperCaseTxnType(value: string) {
   if (value.toLowerCase() === "redeem") {
       value = "deliver";
   }
   return value.toUpperCase();
}

export function convertMilliSecondsToString(value: number) {
    const date = new Date(value);
    return date.toDateString();
}

export function insideHeader(title: string, handleClick: any, bgColor?: string) {
    return(
        <div className={"d-flex py-3 px-5 align-items-center"}
             style={{margin: "0 -40px", background: bgColor ? bgColor : "#FFFFFF"}}
        >
            <span onClick={() => handleClick()}>
                <i className="fa fa-chevron-left"
                   style={{color: "#000000", fontSize: "1.2rem", marginTop: "6px"}}
                />
            </span>
            <h6 className="m-auto m-0"><b style={{color: "#000000"}}>{title}</b></h6>
        </div>
    );
}

export function orderStatusVerification(status: string) {
    return(
        <div className="text-center text-secondary">
            {status.toLocaleLowerCase() === "success" ? (
                <div>
                    <img src={`${imageBaseUrl}/img/icons/eGold/success.png`} width={"50"} />
                    <p className="mt-3 m-0 p-1" style={{ color: "#28a796" }}>
                        Order Successful
                    </p>
                </div>
            ) : (
                <div>
                    <img src={`${imageBaseUrl}/img/icons/eGold/error.png`} width={"80"} />
                    <h5 className="mt-3 text-danger">Order Failed</h5>
                        <small className="d-block px-3 py-2">
                          Any amount deducted from your bank account will be refunded in 3-7
                          business days
                        </small>
                </div>
            )}
        </div>

);
}

export function convertUTCtoLocalString(date: string) {
    return moment.utc(date).local().format("L LT");
}
